export default __webpack_public_path__ + "static/media/audio.1bb2f9a7.gif";